import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
import axios from "axios";
// Import setLoading if it's required
import { setLoading } from "../loading/loadingSlice"; // Make sure the path is correct

// GET ALL ARTICLE
export const getNationalIdList = createAsyncThunk("api/v1/cc/national_id/category", async (_, { dispatch }) => {
  try {
    dispatch(setLoading(true)); // Ensure setLoading is correctly imported or used
    const response = await api.get(`api/v1/cc/national_id/category`);
    return response.data;
  } catch (error) {
    console.error("Error fetching NationalId :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching NationalId list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false)); // Ensure setLoading is correctly imported or used
  }
});

// GET National ID Countries
export const getNationalIdCountries = createAsyncThunk("nationalId/getCountries", async () => {
  const response = await api.get("/api/v1/cc/national_id/countries"); // Adjust the URL as needed
  return response.data; // Ensure this returns the structure { status: 'success', data: { countries: [...] } }
});

// POST new National ID Category
// export const postNationalIdCategory = createAsyncThunk(
//   "api/v1/cc/national_id/category/post",
//   async (newCategory, { dispatch }) => {
//     try {
//       dispatch(setLoading(true)); // Ensure setLoading is correctly imported or used
//       const response = await api.post(
//         `api/v1/cc/national_id/category`,
//         newCategory
//       );
//       return response.data;
//     } catch (error) {
//       console.error("Error creating National ID category:", error);
//       const errorMessage =
//         error.response && error.response.data
//           ? error.response.data.message
//           : "Error creating National ID category";
//       throw new Error(errorMessage);
//     } finally {
//       dispatch(setLoading(false)); // Ensure setLoading is correctly imported or used
//     }
//   }
// );
// export const postNationalIdCategory = createAsyncThunk(
//   "api/v1/cc/national_id/category/post",
//   async (newCategory, { dispatch }) => {
//     try {
//       dispatch(setLoading(true));
//       const response = await api.post(
//         `api/v1/cc/national_id/category`,
//         newCategory
//       );
//       return response.data;
//     } catch (error) {
//       console.error("Error creating National ID category:", error);
//       throw new Error(errorMessage);
//     } finally {
//       dispatch(setLoading(false));
//     }
//   }
// );
export const postNationalIdCategory = createAsyncThunk("api/v1/cc/national_id/category/post", async (newCategory, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.post(`api/v1/cc/national_id/category`, newCategory);
    return response.data;
  } catch (error) {
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error creating National ID category";
    console.error("Error creating National ID category:", errorMessage);
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
